import * as React from "react";
import "./import-naming-panel.scss";
import {cx}                     from "emotion";
import {bindInput}              from "@Common/react/bind-input";
import {scopedState}            from "@Common/react/scoped-state";
import {stateChangeNestedValue} from "@Common/react/state-change-nested-value";
import {CheckboxLine}           from "@Common/ui-components/heavy/mailing-ui/create-mailing-list-modal/types/demographics/step-2-customize/form/checkbox-line/checkbox-line";
import {RadioOption}            from "@Common/ui-components/heavy/mailing-ui/create-mailing-list-modal/types/common/radio-option/radio-option";

import {Select} from "@Common/ui-components/heavy/common/design2/select/select";
import {Checkbox} from "@Common/ui-components/heavy/common/design2/checkbox/checkbox";
import {InformationBadge} from "@Common/ui-components/heavy/common/design2/information-badge/information-badge";

export const ImportNamingPanel = ({data, addAdditionalOptions=undefined, customNameCss=null, showErrors, controls=undefined, xdQaName=undefined}) => {
    const ownerOptions = ["OR RESIDENT","OR OCCUPANT","OR HOMEOWNER"];
    const Option = ({ label, value, extra=undefined, xdQaName=undefined}) => {
        const selected = data.value.defaultName2 === value || 
        (value === '' && ownerOptions.indexOf(data.value.defaultName2) !==  -1);
        return RadioOption({
            label,
            selected,
            extra: selected && extra?.(),

            onSelect: () => {
                addAdditionalOptions.onChange(false);
                stateChangeNestedValue(data, ["defaultName2"], () => value);
            },
            xdQaName: xdQaName+" "+label,
        });
    };
    return (
        <div className="import-naming-panel-l3u">
            <div className="dual-panel">
                <div className="left" xd-qa-type="label" xd-qa-name={xdQaName+" Assign Names Description"}>
                    Choose how you want the resident to appear for addresses you have selected.
                    {data.value.defaultName2 === 'custom' && (
                        <div className="additional-info">
                            <div className="heading-section"><img className="address-image" src='/next_images/Address-Warning.svg'/>{"Not recommended for"}</div>
                            <div className="list-section">
                                Capturing leads on your Lead Analytics Dashboard, as original recipient names will be replaced.
                            </div>
                        </div>
                    )}
                    {((data.value.defaultName2 === '' && addAdditionalOptions?.value) || ownerOptions.indexOf(data.value.defaultName2) !==  -1) && (
                        <div className="additional-info">
                            <div className="heading-section"><img className="address-image" src='/next_images/Address-Success.svg'/>{"Good for"}</div>
                            <ul className="list-section">
                                <li>
                                    Improved deliverability rate and reduced returned mail
                                </li>
                                <li>
                                    Delivering to the address and not the person
                                </li>
                                <li>
                                    Apartments due to high residency turnover
                                </li>
                            </ul>
                            <div className="heading-section"><img className="address-image" src='/next_images/Address-Warning.svg'/>{"Not recommended for"}</div>
                            <ul className="list-section">
                                <li>
                                    PO Box addresses
                                </li>
                                <li>
                                    Areas with high seasonal residency
                                </li>
                            </ul>
                        </div>
                    )}
                </div>
                <div className="right">
                {Option({
                        value: "",
                        label: "Use resident name",
                        xdQaName: "Use resident name",
                    })}
                    <div className="options">
                        {(data?.value?.defaultName2 === '' || ownerOptions.indexOf(data.value.defaultName2) !==  -1) && (
                            <div
                                className="apply-to-owner-section"
                            >
                                <div className="checkbox-div" 
                                    onClick={() => {
                                        if(addAdditionalOptions.value) {
                                            data.onChange({defaultName2: ""});
                                        } else {
                                            data.onChange({defaultName2: "OR RESIDENT"});
                                        }
                                        addAdditionalOptions.change(v => !v);
                                    }}>
                                    {Checkbox({
                                        checked: addAdditionalOptions?.value,
                                    })}
                                </div>
                                <div className="add-label">
                                    Add
                                </div>
                                {(data?.value?.defaultName2 === '' || ownerOptions.indexOf(data.value.defaultName2) !==  -1) &&
                                    Select({
                                                forcedExpandLeft: true,
                                                disabled: !addAdditionalOptions?.value,
                                                className: 'address-options-select',
                                                list: [
                                                    {
                                                        value: "OR RESIDENT",
                                                        label: "OR RESIDENT",
                                                    },
                                                    {
                                                        value: "OR OCCUPANT",
                                                        label: "OR OCCUPANT",
                                                    },
                                                    {
                                                        value: "OR HOMEOWNER",
                                                        label: "OR HOMEOWNER",
                                                    },
                                                ],
                                                itemToLabel: (e) => e?.label,
                                                onChange: (e) => data.onChange({defaultName2: e.value}),
                                                isSelected: (e) => data.value.defaultName2 == e.value,
                                                xdQaName: "Use resident additional options type"
                                            })
                                    }
                                    <span style={{marginLeft: "5px", marginTop: "7px"}}>
                                        {InformationBadge({
                                            getTooltip: () => "Appears below resident name",
                                            xdQaName: "Select options tooltip",
                                        })}
                                    </span>
                            </div>
                        )}
                    </div>
                    {CheckboxLine({
                        text: "Replace name on import?",
                        state: scopedState(data, ["replaceName"]),
                        xdQaName: xdQaName+" Replace recipient name on import?",
                    })}
                    {data.value.replaceName &&
                        <div className="field">
                            <input {...{
                                autoFocus: true,
                                placeholder: "Custom name...",
                                maxLength: 50,
                                className: cx(customNameCss, {hasError: showErrors && !data.value.defaultName}),
                                ...bindInput(scopedState(data, ["defaultName"])),
                                "xd-qa-type": "text_field",
                                "xd-qa-name": xdQaName+" Replace name",
                            }}/>
                        </div>
                    }
                </div>
            </div>
            {/* <div className="dual-panel">
                <div className="left" xd-qa-type="label" xd-qa-name={xdQaName+" Assign Names Seasonal Description"}>
                    These options are NOT recommended for states with high seasonal residency (e.g. Florida).
                </div>
                <div className="right">

                    {Option({
                        value: "",
                        label: "None",
                        xdQaName,
                    })}
                    {Option({
                        value: "OR RESIDENT",
                        label: "Add \"OR RESIDENT\" below recipient name on import",
                        xdQaName,
                    })}
                    {Option({
                        value: "OR OCCUPANT",
                        label: "Add \"OR OCCUPANT\" below recipient name on import",
                        xdQaName,
                    })}
                    {Option({
                        value: "OR HOMEOWNER",
                        label: "Add \"OR HOMEOWNER\" below recipient name on import",
                        xdQaName,
                    })}
                </div>
            </div> */}
        </div>
    );
};
